import NavigationDropdown, { NavigationDropdownProps } from '@/components/NavigationDropdown';

import { DropdownItem } from '@/components/Dropdown';
import { PermissionAuth } from '@/components/HasPermission';
import { ReactNode } from 'react';
import reportTypes from '@/pages/Reports/DynamicReport/reportTypes';
import useSession from '@/state/session';

export type ReportTypeDropdownProps = Omit<NavigationDropdownProps, 'items'>;

// Report types that only appear in the dropdown when the user holds the matching permission.
const reportTypePermissions: Partial<Record<keyof typeof reportTypes, keyof PermissionAuth>> = {
  trainingReport: 'allowViewTrainingReport',
};

const reportTypeDropdownItems: (DropdownItem & { permission?: keyof PermissionAuth })[] = Object.entries(reportTypes).map(
  ([value, [label]]: [string, string[]]): DropdownItem & { permission?: keyof PermissionAuth } => ({
    label,
    value: `/reports/${value}`,
    permission: reportTypePermissions[value as keyof typeof reportTypes],
  })
);

const ReportTypeDropdown = (props: ReportTypeDropdownProps): ReactNode => {
  const auth = useSession(({ state }) => state.config?.auth);
  const items = reportTypeDropdownItems.filter(({ permission }) => !permission || !!auth?.[permission]);

  return <NavigationDropdown name="reportTypeNavigationDropdown" {...props} items={items} />;
};

export default ReportTypeDropdown;
